<template>
  <a-modal
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="1536"
    wrapClassName="registraContainer"
    :footer="null"
    :centered="true"
    :bodyStyle="{ height: '850px' }"
    :maskClosable="false"
  >
    <template #title>
      <ArrowLeftOutlined v-if="!(showType === 'scheduleTable')" @click="handleNumberCancel" />
      <span>{{ registerParams.hospital }}</span>
    </template>
    <a-form
      :model="registerParams"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      class="search"
      :rules="rules"
      ref="formRef"
      :style="{ display: showType === 'scheduleTable' ? 'block' : 'none' }"
    >
      <a-row>
        <a-col :span="span">
          <a-form-item label="院区名称" name="branchHospitalId">
            <a-select
              v-model:value="registerParams.branchHospitalId"
              placeholder="请选择院区名称"
              :options="branchList"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="span">
          <a-form-item label="科室名称" name="departmentId">
            <a-select
              v-model:value="registerParams.departmentId"
              placeholder="请选择科室名称"
              :options="departmentList"
              show-search
              :filter-option="false"
              :show-arrow="true"
              :default-active-first-option="false"
              @search="getDepartmentList"
              @change="handleDepartmentChange"
              @focus="() => getDepartmentList('')"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="span">
          <a-form-item label="医生名称" name="doctorId">
            <a-select
              v-model:value="registerParams.doctorId"
              placeholder="请选择医生名称"
              show-search
              :filter-option="false"
              :show-arrow="true"
              :options="doctorList"
              :default-active-first-option="false"
              @change="handleDoctorChange"
              @search="getDoctorList"
              @focus="() => getDoctorList('')"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="span">
          <CusButton style="width: 80px; margin-left: 8px" type="primary" @click="handleSearch">
            查询
          </CusButton>
        </a-col>
      </a-row>
    </a-form>
    <!-- 医生信息 -->
    <DoctorInfo :data="doctorDetails" :loading="infoLoading" />
    <!-- 医生排班列表 -->
    <div class="tableContent" :style="{ display: showType === 'scheduleTable' ? 'block' : 'none' }">
      <a-spin :indicator="indicator" v-if="scheduleTableLoading" />
      <div v-else>
        <div v-if="scheduleData?.length === 0">
          <div class="z-fixed-c">
            <auth-img class="empty-img" src="@/assets/img/empty.png" />
          </div>
          <div class="z-fixed-c empty-txt">暂无数据</div>
        </div>
        <ScheduleTable
          v-else
          :scheduleList="item"
          v-for="item in scheduleData"
          :key="item.departmentId"
          @handleSelect="handleScheduleSelect"
        />
      </div>
    </div>
    <!-- 号源 -->
    <NumberSource
      :style="{ display: showType === 'scheduleTable' ? 'none' : 'block' }"
      :data="numberSourceData"
      :registerParams="registerParams"
      :loading="numberSourceLoading"
      :ucPatientId="ucPatientId"
      :ucDoctorId="ucDoctorId"
      @handleConfirm="handleConfirm"
      ref="numberSourceRef"
    />
    <!-- 预约结果通知 -->
    <ResultReminder :visible="resultVisible" :data="resultData" @handleOk="handleResultOk" />
  </a-modal>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, h, nextTick } from 'vue'
import CusButton from '@/components/cus-Button'
import DoctorInfo from './components/DoctorInfo.vue'
import NumberSource from './components/NumberSource.vue'
import ResultReminder from './components/ResultReminder.vue'
import ScheduleTable from './components/ScheduleTable.vue'
import {
  getScheduling,
  getNumberSource,
  appointRegister,
  getHospitalBranch,
  getDepartment,
  getDoctor,
  getDoctorDetail,
  getPatientDetail
} from '@/api/Todo'
import { LoadingOutlined, ArrowLeftOutlined } from '@ant-design/icons-vue'

const span = 5
const labelCol = { span: 7 }
const wrapperCol = { span: 17 }
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  patientId: {
    type: Number,
    default: null
  },
  doctorId: {
    type: Number,
    default: null
  },
  ucDoctorId: {
    type: Number,
    default: null
  },
  ucPatientId: {
    type: Number,
    default: null
  }
})
const emit = defineEmits(['setVisible'])

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '30px'
  },
  spin: true
})
const formRef = ref() // 表单
const numberSourceRef = ref()
const resultVisible = ref(false) // 挂号结果确认弹窗是否可视
const realnameAuthVisible = ref(false) // 实名认证弹窗是否可视
const numberSourceData = ref([]) // 号源数据
const phone = ref('') // 患者手机号
const scheduleTableLoading = ref([]) // 排班表loading
const infoLoading = ref([]) // 医生信息loading
const numberSourceLoading = ref([]) // 号源列表loading
const branchList = ref([]) // 院区列表
const departmentList = ref([]) // 科室列表
const doctorList = ref([]) // 医生列表
const doctorDetails = ref({}) // 医生详情
const scheduleData = ref([]) // 排班列表
const resultData = ref({}) // 挂号结果数据
const showType = ref('scheduleTable')
const registerParams = ref({
  branchHospitalId: '',
  departmentId: '',
  shiftScheduleId: '',
  registrationNumber: '',
  ucDoctorId: props.ucDoctorId,
  doctorId: props.doctorId,
  patientId: props.patientId,
  ucPatientId: props.ucPatientId,
  reserveDate: '',
  departmentName: '',
  amPmId: ''
})
const rules = {
  branchHospitalId: [{ required: true, message: '请选择院区名称' }],
  departmentId: [{ required: true, message: '请选择科室名称' }],
  doctorId: [{ required: true, message: '请选择医生名称' }]
}

// 搜索
const handleSearch = () => {
  formRef.value
    .validate()
    .then(() => {
      getSchedulingList()
    })
    .catch(err => {
      console.log('error', err)
    })
}

// 获取院区列表
const getHospitalBranchList = async () => {
  try {
    const data = (await getHospitalBranch({ hospitalId: registerParams.value.hospitalId })) || []
    const list = data?.map(item => ({ label: item.branchName, value: item.branchId }))
    registerParams.value = {
      ...registerParams.value,
      branchHospitalId: list[0]?.value ? list[0]?.value : ''
    }
    branchList.value = list
  } catch (error) {
    console.log(error)
    branchList.value = []
  }
}

// 获取科室列表
const getDepartmentList = async val => {
  try {
    const params = {
      name: val,
      pageNum: 1,
      pageSize: 999
    }
    const result = (await getDepartment(params)) || {}
    const { list } = result || []
    departmentList.value = list.map(item => ({ label: item.name, value: item.id }))
  } catch (error) {
    console.log(error)
    departmentList.value = []
  }
}

// 获取医生列表
const getDoctorList = async val => {
  try {
    const { departmentId, hospitalId } = registerParams.value
    const params = {
      name: val,
      departmentId,
      hospitalId,
      pageNum: 1,
      pageSize: 999
    }
    const result = (await getDoctor(params)) || {}
    const { list } = result || []
    doctorList.value = list.map(item => ({
      label: item.doctorName,
      value: item.doctorId,
      ucDoctorId: item.ucUserId
    }))
  } catch (error) {
    console.log(error)
    doctorList.value = []
  }
}

// 获取排班列表
const getSchedulingList = async () => {
  try {
    scheduleTableLoading.value = true
    infoLoading.value = true
    const { branchHospitalId, departmentId, doctorId } = registerParams.value
    const params = {
      branchHospitalId,
      departmentId,
      doctorId,
      hospitalId: doctorDetails.value.hospitalId
    }
    const data = (await getScheduling(params)) || []
    scheduleTableLoading.value = false
    // 获取医生详情
    getDepartmentByDoctor()
    infoLoading.value = false
    scheduleData.value = data?.map(item => ({ ...item, hospital: registerParams.value.hospital }))
  } catch (error) {
    console.log(error)
    scheduleTableLoading.value = false
  }
}

// 根据医生id和排班获取号源
const getNumberSourceList = async params => {
  try {
    numberSourceLoading.value = true
    const result = (await getNumberSource(params)) || []
    numberSourceLoading.value = false
    numberSourceData.value = result
  } catch (error) {
    console.log(error)
  }
}

// 查询医生详情
const getDepartmentByDoctor = async () => {
  const data = (await getDoctorDetail(registerParams.value.doctorId)) || []
  const doctorInfo = data[0] || {}
  const { department, name, hospital, hospitalId } = doctorInfo
  registerParams.value = {
    ...registerParams.value,
    doctorName: name,
    departmentName: department,
    hospital,
    hospitalId
  }
  doctorDetails.value = doctorInfo
}

// 选择排班
const handleScheduleSelect = val => {
  const { ucDoctorId, doctorId } = registerParams.value
  const { shiftScheduleId, shiftScheduleDate, departmentName, amPmId, week } = val
  const params = {
    ucDoctorId,
    doctorId,
    schedulId: shiftScheduleId
  }
  getNumberSourceList(params)
  registerParams.value = {
    ...registerParams.value,
    shiftScheduleId,
    reserveDate: shiftScheduleDate,
    departmentName,
    amPmId,
    week
  }
  showType.value = 'sourceNumber'
}

// 提交
const handleConfirm = async val => {
  try {
    const { registrationNumber, visitTimeSlot, reserveDate, visitTime, patientProfileId } = val
    const params = {
      ...registerParams.value,
      registrationNumber,
      visitTimeSlot,
      patientProfileId,
      reserveDate: `${reserveDate} ${visitTime}`
    }
    const data = (await appointRegister(params)) || {}
    resultData.value = data
    resultVisible.value = true
  } catch (error) {
    console.log(error)
    if (error === '患者没有认证') {
      realnameAuthVisible.value = true
      const data = (await getPatientDetail(registerParams.value.patientId)) || {}
      phone.value = data.phone
    }
  }
}

// 关闭预约挂号
const handleCancel = () => {
  showType.value = 'scheduleTable'
  emit('setVisible')
}

// 选择科室名称回调
const handleDepartmentChange = () => {
  registerParams.value.doctorId = ''
}

// 选择医生名称回调
const handleDoctorChange = val => {
  const selectDoctor = doctorList.value.filter(item => item.value === val)
  console.log(selectDoctor)
  registerParams.value.ucDoctorId = selectDoctor[0]?.ucDoctorId
}

// 预约结果通知确认
const handleResultOk = () => {
  const { appointResult } = resultData.value
  // 预约成功
  if (appointResult) {
    resultVisible.value = false
    handleCancel()
  } else {
    resultVisible.value = false
  }
}

// 关闭号源
const handleNumberCancel = () => {
  showType.value = 'scheduleTable'
  numberSourceRef.value.handleCancel()
}

const init = async () => {
  getDepartmentList()
  await getDepartmentByDoctor()
  registerParams.value = {
    ...registerParams.value,
    departmentId: doctorDetails.value.departmentId,
    hospitalId: doctorDetails.value.hospitalId
  }
  nextTick(async () => {
    await getHospitalBranchList()
    handleSearch()
  })
}

watch(
  () => props.visible,
  async val => {
    if (val) {
      init()
    }
  }
)

watch(
  () => registerParams.value.departmentId,
  () => {
    getDoctorList()
  }
)
</script>

<style lang="scss" scoped>
.registraContainer {
  ::v-deep(.ant-modal-content .ant-modal-body) {
    padding: 18px 0 23px 0;
  }
  .anticon {
    margin-right: 12px;
  }
  .search {
    margin-bottom: 24px;
    border-bottom: 1px solid #f2f2f2;
  }
  .tableContent {
    height: 500px;
    overflow-y: auto;
    text-align: center;
    ::v-deep(.ant-spin) {
      margin: 180px 0;
    }
    .empty-img {
      margin-top: 50px;
    }
    .empty-txt {
      font-size: 14px;
      color: #999999;
      margin-top: 17px;
    }
  }
}
::v-deep(.ant-modal-footer) {
  text-align: center;
  border-top: 0;
}
</style>
